import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const Mortage: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M7.85377 50.3406V20.6671L5.51874 20.5496L28.3841 7.21338L51.2354 20.5496L48.9007 21.2528V50.3406H7.85377Z" stroke={props.htmlColor || "black"} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="40.2722" cy="43.779" r="12.5753" fill={props.htmlColor || "#FFCB06"} stroke="white" strokeWidth="1.23166"/>
      <path d="M45.6508 37.7796L34.8936 49.7787" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="36.4505" cy="39.9143" r="2.95239" stroke="white"/>
      <circle cx="44.1935" cy="47.6177" r="2.95239" stroke="white"/>
    </SvgIcon>
  );
};

export default Mortage;
